import RoutesComponent from './presentation/routes/RoutesComponent';
import ModalsProviderImpl from './presentation/providers/modal/ModalsProviderImpl';
import "./App.scss";

const App = () => {
  return (
    <ModalsProviderImpl.Provider>
      <RoutesComponent />
    </ModalsProviderImpl.Provider>
  );
}

export default App;
